import KulapAPIProvider from './kulapApi'
import AwsS3APIProvider from './awsS3Api'

export const kulapApi = new KulapAPIProvider()
export const awsS3Api = new AwsS3APIProvider()



// WEBPACK FOOTER //
// ./src/resources/index.js